import Topic1 from "../img/topic/1.png"
import Topic2 from "../img/topic/2.png"
import Topic3 from "../img/topic/3.png"
import Topic4 from "../img/topic/4.png"
import Topic5 from "../img/topic/5.png"
import Topic6 from "../img/topic/6.png"


export default [
    {
        id: 1,
        title: "Business & Management",
        image: Topic1,
        subtitle: 'Learn the fundamentals of managing a business planning & organizing.'
    },
    {
        id: 2,
        title: "IT & Software",
        image: Topic4,
        subtitle: 'Learn the fundamentals of IT, including computer hardware.'
    },
    {
        id: 3,
        title: "Teaching & Academics",
        image: Topic6,
        subtitle: 'Explore the core principles and methodologies of effective teaching.'
    },
    {
        id: 4,
        title: "Economics",
        image: Topic3,
        subtitle: 'Explore the functioning of financial markets, derivatives, and risk management. '
    },
    {
        id: 5,
        title: "Marketing",
        image: Topic5,
        subtitle : 'Learn the core principles of market research and targeting.'
    },
    {
        id: 6,
        title: "Development",
        image: Topic2,
        subtitle : 'Discover foundational concepts and techniques for self-improvement.'
    },
];
